import React from "react";
import "./styles.css";
import { Container } from "@mui/material";
import { FaYoutube, FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer-container">
      <Container maxWidth="xl">
        <div className="footer-content">
          <div>
            <div className="footer-title">
              <span style={{ color: "#f28f1a" }}>S V </span>Interiors
            </div>
            <p className="footer-subtitle">Contact Info</p>
            <p
              className="footer-address"
              onClick={() =>
                window.open(
                  "https://maps.google.com/?q=12.87911636933591,77.53900879867109",
                  "_blank"
                )
              }
            >
              No.73, 2, 100 Feet Rd,
              <br /> Bengaluru, Karnataka
              <br /> 560062
            </p>
            <div
              className="footer-email"
              onClick={() => window.open("mailto:shreevinteriors@gmail.com")}
            >
              shreevinteriors@gmail.com
            </div>
            <div
              className="footer-phone"
              onClick={() => window.open("tel:+9036640175")}
            >
              9036640175
            </div>
          </div>
          <div>
            <div className="footer-subtitle">Menu</div>
            <br />
            <div>
              <Link style={{ textDecoration: "none", color: "#fff" }} to="/">
                Home
              </Link>
            </div>
            <div>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/about"
              >
                About
              </Link>
            </div>
            <div>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/contact-us"
              >
                Contact Us
              </Link>
            </div>
            <div>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/portfolio"
              >
                Services
              </Link>
            </div>
            <div>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/portfolio"
              >
                Portfolio
              </Link>
            </div>
            <div>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/factory-and-machinery"
              >
                Machinery
              </Link>
            </div>
            <div>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/testimonials"
              >
                Testimonials
              </Link>
            </div>
          </div>
          <div>
            <div className="footer-subtitle">Connect Online</div>
            <div className="footer-social-icons">
              {/* Add icons with links */}
              <a
                href="https://www.youtube.com/channel/UCxBFbUj9lEfDOyN7_m-LSkg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube color="#fff" size={45} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61556304023068"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook color="#fff" size={45} />
              </a>
              <a
                href="https://www.instagram.com/shreevaishnaviinteriors/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram color="#fff" size={45} />
              </a>
            </div>
            <div>
              <a
                href="https://wa.me/+919036640175?text=Hello"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-whatsapp-enquiry"
              >
                <span>
                  <FaWhatsapp color="#fff" size={45} />
                </span>{" "}
                How can i help you?
              </a>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Footer;
